import { useEffect, useState } from "react";
import fallback from "../nav-fallback.json";

const NAV_URL = import.meta.env.VITE_NAV_URL || "https://seiutwrstorage.blob.core.windows.net/nav-published/nav.json";
const CACHE_KEY = "seiu.nav.v1";
const CACHE_TTL_MS = 5 * 60 * 1000;

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { data, fetchedAt } = JSON.parse(raw);
    if (Date.now() - fetchedAt > CACHE_TTL_MS) return null;
    return data;
  } catch {
    return null;
  }
}

function writeCache(data) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ data, fetchedAt: Date.now() }));
  } catch {
    /* quota / disabled — ignore */
  }
}

export function useNav() {
  const [nav, setNav] = useState(() => readCache() || fallback);
  const [source, setSource] = useState(readCache() ? "cache" : "fallback");

  useEffect(() => {
    let cancelled = false;
    fetch(NAV_URL, { cache: "no-cache" })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        if (cancelled) return;
        if (!data?.categories?.length) throw new Error("empty nav");
        setNav(data);
        setSource("network");
        writeCache(data);
      })
      .catch(() => {
        /* keep cache-or-fallback — don't surface to user */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { nav, source };
}
